<template>
  <div class="spinner">chargement...</div>
</template>

<script>
/**
 * A pure css Spinner
 */
export default {
  name: 'LoadingSpinner'
}
</script>

<style lang="scss" scoped>
@import './Spinner.scss';
</style>
